export enum EntityTypes {
  job = 1,
  jobMilestones = 2,
  jobReview = 3,
  resume = 4,
  educationLevel = 5,
  sectorType = 6,
  jobType = 7,
  salaryType = 8,
  genderType = 9,
  country = 10,
  languages = 11,
}
